module.exports = __webpack_public_path__ + "img/Calendar.fdc0c14c.svg";